import { useRef, useLayoutEffect } from "react";
import { state } from "../../state/workspaceStore.js";
import { product } from "../../utils/domain/model.js";
import { esc } from "../../utils/format.js";
import { field, area, btn } from "../forms/FormControls.jsx";
import { closeDialog } from "../../state/uiActions.js";
export function ActionDialog() {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (el && !el.open) el.showModal();
    el?.querySelector("input,button")?.focus();
    return () => el?.close?.();
  }, []);
  let content;
  if (state.dialog.kind === "stock") {
    let [pid, sid] = state.dialog.id.split("|"),
      p = product(state.db, pid),
      s = p.skus.find((s) => s.id === sid);
    content = (
      <form id={"stock-form"}>
        <h2 id={"dialog-title"}>{"Adjust stock"}</h2>
        <p>
          {esc(p.name)}
          {" \xB7 "}
          {esc(s.code)}
        </p>
        <div className={"form-grid"}>
          {field(
            "New available stock",
            "stock",
            s.stock,
            "number",
            'min="0" step="1" required',
          )}
          {field(
            "Low-stock threshold",
            "threshold",
            s.threshold,
            "number",
            'min="0" step="1" required',
          )}
        </div>
        {area("Reason *", "reason", "")}
        <p id={"dialog-error"} className={"error"} role={"alert"}></p>
        <div className={"dialog-actions"}>
          {btn("Cancel", 'data-action="close-dialog"', true)}
          <button className={"btn"} type={"submit"}>
            {"Save adjustment"}
          </button>
        </div>
      </form>
    );
  } else {
    let messages = {
      logout: ["Log out?", "Are you sure you want to log out?"],
      "delete-coupon": [
        "Delete coupon?",
        "Future orders cannot use this coupon. Historical discounts remain unchanged.",
      ],
      "delete-alias": [
        "Delete coupon alias?",
        "Future orders cannot use this alias. Historical discounts remain unchanged.",
      ],
      "delete-promotion": [
        "Delete promotion?",
        "This disables the global promotion for future orders. It can be configured again from the coupon form.",
      ],
      "archive-product": [
        "Archive product?",
        "It will be hidden from the active catalogue and new orders. Existing order snapshots remain available.",
      ],
      "archive-collection": [
        "Archive collection?",
        "Only collections with no product members can be archived.",
      ],
      "delete-banner": [
        "Delete banner?",
        "This removes the banner and its image from the saved configuration.",
      ],
      reset: [
        "Reset example records?",
        "This replaces all local edits, orders and uploaded images. Export a backup from Profile first.",
      ],
      cancel: [
        "Cancel this order?",
        "Reserved stock will be restored once. The payment record will not be refunded automatically.",
      ],
    };
    const [title, body] = messages[state.dialog.kind] || [
      "Confirm action",
      "Continue with this change?",
    ];
    content = (
      <>
        <h2 id={"dialog-title"}>{title}</h2>
        <p id={"dialog-message"}>{body}</p>
        <p id={"dialog-error"} className={"error"} role={"alert"}></p>
        <div className={"dialog-actions"}>
          {btn("Cancel", 'data-action="close-dialog"', true)}
          {btn(
            state.dialog.kind === "logout" ? "Log out" : "Confirm",
            'data-action="confirm-dialog"',
          )}
        </div>
      </>
    );
  }
  return (
    <dialog
      id="action-dialog"
      className="action-dialog"
      ref={ref}
      aria-labelledby="dialog-title"
      aria-modal="true"
      aria-describedby={
        state.dialog.kind === "stock" ? undefined : "dialog-message"
      }
      onCancel={(e) => {
        e.preventDefault();
        closeDialog();
      }}
    >
      {content}
    </dialog>
  );
}
